import { buzz, noise, tone } from './synth';

/**
 * Battleship's sound effects, synthesized on the fly (see `./synth.ts` — no audio files, all
 * best effort, all behind the shared per-device sound toggle).
 */

/** Sonar ping when you line up a shot. */
export function playSonarPing(): void {
  tone({ freq: 1320, dur: 0.5, gain: 0.08 });
  tone({ freq: 1320, dur: 0.4, gain: 0.025, delay: 0.32 });
}

/** The shell's whistle on the way out. */
export function playFire(): void {
  tone({ freq: 1700, to: 650, dur: 0.5, gain: 0.045 });
  noise({ dur: 0.18, gain: 0.18, filter: 900, filterTo: 300, q: 0.7 });
  buzz(12);
}

export function playSplash(): void {
  noise({ dur: 0.55, gain: 0.24, filter: 1900, filterTo: 450, q: 0.7, attack: 0.012 });
  tone({ freq: 320, to: 120, dur: 0.16, gain: 0.05 });
  buzz(10);
}

export function playHit(): void {
  noise({ dur: 0.75, gain: 0.5, filter: 1000, filterTo: 70, q: 0.6 });
  tone({ freq: 130, to: 40, dur: 0.5, gain: 0.32 });
  buzz([30, 40, 60]);
}

/** A hit that finished a ship: the boom, then a long low rumble and a sinking glide. */
export function playSunk(): void {
  playHit();
  noise({ dur: 1.3, gain: 0.28, filter: 320, filterTo: 55, q: 0.8, delay: 0.25, attack: 0.15 });
  tone({ freq: 330, to: 95, type: 'triangle', dur: 1, gain: 0.06, delay: 0.3 });
  buzz([60, 50, 120]);
}
